import styled from 'styled-components'
import tw from 'tailwind-styled-components'

export const MenuItemWrapper = tw.div`
  flex items-center align-middle rounded-4 cursor-pointer bg-blackRussianHover bg-transparent
`

export const CollapsedIconWrapper = tw.div`
  p-11 text-white
`

export const LinearGradientBorder = styled.div`
  height: 37px;
  width: 100%;
  border-radius: 4px;
  position: relative;
  z-index: 1;
  border: 1px solid transparent;

  /* Create the gradient border using an inset box shadow */
  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    z-index: -1;
    border-radius: 4px;
    padding: 2px;
    background: linear-gradient(138deg, #3ccea2 4.77%, #ffd600 104.98%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude; /* Safari */
    -webkit-mask-composite: xor; /* Chrome */
  }
`

export const ExpandedMenu = styled(LinearGradientBorder)`
  height: 50px;
  background-color: #1b1b1e;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ItemsWrapper = tw.div``

export const UpperContentWrapper = tw.div`
  flex items-center space-x-13 text-white whitespace-nowrap overflow-hidden
`

export const Title = tw.span`
  text-white text-xs leading-5 font-semibold whitespace-nowrap overflow-hidden
`

export const WagerLeftItem = tw.span`
  text-xs text-yellow font-semibold truncate
`

export const LowerContentWrapper = tw.div`
  text-3xs text-yellow font-bold px-3 pt-3 whitespace-nowrap overflow-hidden
`

export const ButtonWrapper = tw.div`
  absolute right-3
`

export const CustomTimerText = tw.div`
  whitespace-nowrap overflow-hidden
`

export const TransitionWrapper = tw.div`
  transition-all duration-250 ease-linear
`
